<template>
  <div>
    <h4>社會科</h4>
    <h5>6年級社會班</h5>
    <p>
      六年級社會課程主要辦給欲參加衛道中學入學測驗的同學們，因衛道入學測驗納入社會科，社會班可以幫你整理內容、加強記憶、學會解題！讓你考試一帆風順！
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/scss/course.scss";
</style>
